import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Layout from "./components/layout/Layout";
import Login from "./pages/Login";
import NewEcho from "./pages/NewEcho";
import PreviousEchos from "./pages/PreviousEchos";
import OneToOneMeeting from "./pages/Feedback.screen";
import FeedbackLoader from "./pages/FeedbackLoader";
import InterviewComplete from "./pages/InterviewComplete.screen";
import EchoReport from "./pages/EchoReport";
import EchoSessions from "./pages/EchoSessions";
import EchoSuccess from "./pages/EchoSuccess";
import Products from "./pages/Products";
import Dashboard from "./pages/Dashboard";
import { ToastContainer, toast } from "react-toastify";

function App() {
  // This would normally come from your auth state management
  const isAuthenticated = true;

  return (
    <>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/feedback" element={<OneToOneMeeting />} />
          <Route path="/feedback-loader" element={<FeedbackLoader />} />
          <Route path="/interview-complete" element={<InterviewComplete />} />

          {/* Protected Routes */}
          <Route
            path="/*"
            element={
              isAuthenticated ? (
                <Layout>
                  <Routes>
                    <Route path="/new-echo" element={<NewEcho />} />
                    <Route path="/previous-echos" element={<PreviousEchos />} />
                    <Route path="/echo-report/:id" element={<EchoReport />} />
                    <Route path="/echo-success" element={<EchoSuccess />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route
                      path="/echo/:echoId/sessions"
                      element={<EchoSessions />}
                    />
                    <Route
                      path="/"
                      element={<Navigate to="/new-echo" replace />}
                    />
                  </Routes>
                </Layout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
